import { BinInfo } from "../staticInfo/state";

export type CollectionState = {
    collectionDetail: CollectionDetail[] | null;
    signature_image: string | null;
    signature_image_thumb: string | null;
    attendanceCollectionInfo: AttendanceCollectionInfo[] | [];
    unloadCollectionInfo: UnloadCollectionInfo[] | [];
    unloadImageList: UnloadImageList[] | [];
    collectionPhotoList: CollectionPhotoList[] | [];
    selectedEditattendanceCollection?:AttendanceCollectionInfo|{}
    selectedEditCollectionDetail?: CollectionDetail
    selectedUnloadCollectionInfo?:UnloadCollectionInfo
    binInfo?:BinInfo
};

export interface CollectionDetail {
    collection_response_id: number;
    collection_weight: number;
    actual_container_weight: number;
    net_weight: number;
    recyclable: string;
    container: string;
    container_id:string
    recyclable_id:string
}

export interface UnloadImageList {
    unload_image_id: string;
    image: string;
    image_thumb: string;
}

export interface CollectionPhotoList {
    collection_image_id: number;
    image: string;
    image_thumb: string;
}

export interface AttendanceCollectionInfo {
    route_detail_id: number;
    bin_id: number;
    route_id: number;
    time_start: string;
    time_end: string;
    collection_id: number;
    collection_date: moment.Moment | Date |null;
    attendance_date: moment.Moment | Date |null;
    bin_full_name: string;
    code: string;
    contract_id: number;
    contract: string;
    signature_image: string;
    signature_image_thumb: string;
    collection_image_id: number;
    remark:string
    value:string
}

export interface UnloadCollectionInfo {
    unload_id: number;
    unload_detail_id:number
    total_kurbside_weight: number;
    total_school_weight: number;
    depot_id: number;
    depot_cn: string;
    paper_weight: number;
    metal_weight: number;
    plastic_weight:number;
    total_weight: number;
    unload_date: string;
    signature_image: string;
    remark:string

}

export const collectionState: CollectionState = {
    collectionDetail: null,
    signature_image: null,
    signature_image_thumb: null,
    attendanceCollectionInfo: [],
    unloadCollectionInfo: [],
    unloadImageList: [],
    collectionPhotoList: [],
    binInfo:{label:'',value:0}
};
